/**
 * Enum for route data keys used in HISinOne Angular.
 * 
 * Provides an Overview and Documentation for various route data keys used across the application.
 */
export enum HisRouteDataKeys {
    MODULES = 'modules',
    ANONMODULES = 'anonmodules',
    /** Defines a set of rights the user must have to access this route.\Evaluated by `hisCanActivate()`. */
    RIGHTS_HAS_ALL = 'hasAll',
    /** Defines a set of rights the user must have at least one of to access this route.\Evaluated by `hisCanActivate()`. */
    RIGHTS_HAS_ANY = 'hasAny',

    /**
     * Key to provide a custom flow name for persisting search criteria sets.
     * 
     * Used in `HisSearchCriteriaSetService.getFlowNameForSearchCriteriaSets()`.
     */
    SEARCH_CRITERIA_SET_FLOW_NAME = 'searchCriteriaSetFlowName',
}